var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container feedback template-bg-gray",
      class: { "my-position-relative": _vm.isStatus }
    },
    [
      _vm.isStatus
        ? _c(
            "md-card",
            {
              staticClass:
                "request-status loop_container bg-transparent update-request-form-common"
            },
            [
              _c(
                "md-card-content",
                { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main" },
                [
                  _c(
                    "div",
                    { staticClass: "card form-wrapper text-center p-20" },
                    [
                      _c("h4", {
                        staticClass: "template-custom-title",
                        domProps: { innerHTML: _vm._s(_vm.statusMsg) }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isStatus
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "loop_container bg-transparent update-request-form-common"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card form-wrapper",
                        class: { thankupageplr88: _vm.success }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12 text-center" }, [
                            _c("img", {
                              staticClass: "top-logo custom-logo",
                              attrs: {
                                src: _vm.logoURL,
                                alt:
                                  _vm.community.content &&
                                  _vm.community.content.parameter2
                                    ? _vm.community.content.parameter2
                                    : "Community Logo"
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "request-respnose-class my-text-center common-space-from-logo",
                            class: {
                              "email-actionpage-tmsg plr10": !_vm.success
                            }
                          },
                          [
                            !_vm.success
                              ? _c("h1", { staticClass: "template-title" }, [
                                  _vm._v("Say thanks or keep chatting")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.success
                              ? _c(
                                  "h1",
                                  {
                                    staticClass: "template-title",
                                    attrs: { "aria-live": "polite" }
                                  },
                                  [_vm._v("Thank you!")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.success
                              ? _c(
                                  "p",
                                  {
                                    staticClass: "custom-content my-text-center"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Showing your appreciation for a response is critical to building your network.\n                        "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.success,
                                expression: "!success"
                              }
                            ],
                            staticClass: "template-form",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.submitResponse()
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "template-input-text-area",
                                    class: [
                                      { "b-error": _vm.errors.has("comment") },
                                      "form-group",
                                      "pd-remove",
                                      "unsubscribe-height"
                                    ],
                                    staticStyle: { position: "relative" }
                                  },
                                  [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.comment,
                                          expression: "comment"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate.continues",
                                          value: "required|max:500",
                                          expression: "'required|max:500'",
                                          modifiers: { continues: true }
                                        }
                                      ],
                                      staticClass:
                                        "form-control placeholder-bold",
                                      class: {
                                        "request-form-error-border": _vm.errors.has(
                                          "comment"
                                        )
                                      },
                                      attrs: {
                                        name: "comment",
                                        id: "textarea",
                                        rows: "10",
                                        "aria-label": "Say thank you",
                                        placeholder: _vm.commentPlaceholder,
                                        maxlength: _vm.max,
                                        required: "",
                                        "aria-required": "true"
                                      },
                                      domProps: { value: _vm.comment },
                                      on: {
                                        blur: _vm.handleBlur,
                                        focus: _vm.handleFocus,
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.comment = $event.target.value
                                          },
                                          _vm.sanitizeComment
                                        ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "hover-shadow",
                                        staticStyle: {
                                          position: "absolute",
                                          bottom: "10px",
                                          right: "10px",
                                          border: "none",
                                          background: "none",
                                          cursor: "pointer"
                                        },
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.loading,
                                          "aria-label":
                                            "Our magic wand offers ways to thank your advisor.",
                                          "aria-busy": _vm.loading
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.getThankYou(_vm.giveText)
                                          }
                                        }
                                      },
                                      [
                                        _vm.loading
                                          ? [_vm._m(0)]
                                          : [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "center",
                                                    gap: "4px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "magic-wand-ty",
                                                      staticStyle: {
                                                        margin: "0"
                                                      }
                                                    },
                                                    [_vm._v("View Examples")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("img", {
                                                    staticClass:
                                                      "magic-wand-img",
                                                    attrs: {
                                                      src: this.magicWandIcon,
                                                      alt: "",
                                                      width: "20",
                                                      height: "20"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm.errors.has("comment")
                                      ? _c("p", { staticClass: "error" }, [
                                          _vm._v(
                                            _vm._s(_vm.errors.first("comment"))
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-block mlr0" }, [
                              _c("div", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group pd-remove unsubscribe-btn text-center"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn_info template-review-submit template-button template-button-width",
                                        style: _vm.reviewBtn,
                                        attrs: {
                                          type: "submit",
                                          name: "unsubscribe"
                                        }
                                      },
                                      [_vm._v("Submit")]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mlr0" }, [
                              _c(
                                "div",
                                { staticClass: "col-md-12 plr10 text-center" },
                                [
                                  _vm.community.content.responseEngagementTip
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "view-profile-link",
                                          attrs: {
                                            target: "_blank",
                                            href:
                                              _vm.community.content
                                                .responseEngagementTip
                                          }
                                        },
                                        [_vm._v("Not sure what to say?")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.success,
                                expression: "!success"
                              }
                            ]
                          },
                          [
                            _c("div", { staticClass: "give-section" }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "email-request-review" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "template-request-review" },
                                    [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(_vm.advisorDetails.first) +
                                            " " +
                                            _vm._s(_vm.advisorDetails.last) +
                                            " "
                                        ),
                                        _vm.advisorDetails.linkedIn
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "view-profile-link",
                                                attrs: {
                                                  target: "_blank",
                                                  href:
                                                    _vm.advisorDetails.linkedIn
                                                }
                                              },
                                              [_vm._v("(View Profile)")]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _vm.$lodash.has(
                                        _vm.advisorDetails.emails,
                                        0
                                      )
                                        ? _c(
                                            "span",
                                            { staticClass: "email-custom" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.advisorDetails.emails[0]
                                                ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.givesEmail
                                        ? _c(
                                            "span",
                                            { staticClass: "email-custom" },
                                            [_vm._v(_vm._s(_vm.givesEmail))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p", {
                                        staticClass: "font-color",
                                        domProps: {
                                          innerHTML: _vm._s(_vm.giveText)
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "request-section" }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "email-request-review" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "template-request-review" },
                                    [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(_vm.createdByMember.first) +
                                            " " +
                                            _vm._s(_vm.createdByMember.last) +
                                            " "
                                        ),
                                        _vm.advisorDetails.linkedIn
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "view-profile-link",
                                                attrs: {
                                                  target: "_blank",
                                                  href:
                                                    _vm.advisorDetails.linkedIn
                                                }
                                              },
                                              [_vm._v("(View Profile)")]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _vm.$lodash.has(
                                        _vm.createdByMember.emails,
                                        0
                                      )
                                        ? _c(
                                            "span",
                                            { staticClass: "email-custom" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.createdByMember
                                                      .emails[0]
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("h3", [
                                        _vm._v(_vm._s(_vm.ask.subject))
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "font-color" }, [
                                        _vm._v(_vm._s(_vm.ask.text))
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("footer", [
                      _c(
                        "ul",
                        { staticClass: "list-inline text-center footer-links" },
                        [
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.landingPageURL &&
                            _vm.community.content.landingPageURL.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: {
                                      href:
                                        _vm.community.content.landingPageURL,
                                      target: "_blank",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Learn More")]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0)",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Learn More")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.termsConditionsURL &&
                            _vm.community.content.termsConditionsURL.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "links",
                                    attrs: {
                                      href:
                                        _vm.community.content
                                          .termsConditionsURL,
                                      target: "_blank",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Terms Of Use [pdf]")]
                                )
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "javascript:void(0)",
                                      tabindex: "0"
                                    }
                                  },
                                  [_vm._v("Terms Of Use [pdf]")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm.community.content &&
                            _vm.community.content.unsubscribePageURL &&
                            _vm.community.content.unsubscribePageURL.length
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      tabindex: "0",
                                      href:
                                        _vm.community.content
                                          .unsubscribePageURL,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Opt\n                                Out"
                                    )
                                  ]
                                )
                              : _c(
                                  "a",
                                  { attrs: { href: "javascript:void(0)" } },
                                  [_vm._v("Opt Out")]
                                )
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "unsubscribe-community-logo" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              (_vm.community.content &&
                                _vm.community.content.landingPageURL) ||
                              "https://www.protopia.co",
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.footerLogoURL,
                              alt:
                                "Community Logo of " +
                                _vm.community.content.parameter2
                            }
                          })
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-roller" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row my" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("h2", { staticClass: "email-request-title text-center" }, [
          _vm._v("Here's how they helped.")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row my" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("h2", { staticClass: "email-request-title text-center" }, [
          _vm._v("Here's what you asked")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29f43df0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29f43df0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestResponse.vue
// module id = null
// module chunks = 